import classNames from "classnames";
import { InputHTMLAttributes, ReactNode } from "react";

import styles from "./index.module.scss";

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  groupName: string;
  className?: string;
  defaultChecked?: boolean;
  children?: ReactNode;
  checkmarkClassName?: string;
}

function Radio({
  id,
  groupName,
  children,
  className,
  checkmarkClassName,
  ...rest
}: RadioProps) {
  return (
    <label
      htmlFor={id}
      className={classNames(
        styles.Radio,
        "relative inline-flex justify-end items-center text-right cursor-pointer select-none pr-8 transition-colors hover:text-primary-700",
        className
      )}
    >
      {children}
      <input
        className={classNames(styles.Input, "hidden")}
        type="radio"
        id={id}
        name={groupName}
        {...rest}
      />
      <span
        className={classNames(
          "absolute right-0 top-1 shrink-0 w-4 h-4 rounded-full bg-secondary-200 flex justify-center items-center",
          styles.Checkmark,
          checkmarkClassName
        )}
      />
    </label>
  );
}

export { Radio };
